import React, { useState } from 'react';
import { Container, Paper, TextField, Button, Typography, Box, Alert, CircularProgress, Avatar } from '@mui/material';
import api from '../services/api';
// Força o fundo do body com imagem e gradiente igual ao login
import { useEffect } from 'react';

function RecuperarSenha() {
  useEffect(() => {
    const originalBg = document.body.style.background;
    document.body.style.background = `
      linear-gradient(135deg, rgba(25, 118, 210, 0.7) 0%, rgba(255, 152, 0, 0.7) 100%),
      url('${process.env.PUBLIC_URL}/assets/fundo_login.jpg') center/cover no-repeat fixed
    `;
    return () => {
      document.body.style.background = originalBg;
    };
  }, []);
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');
    if (!email) {
      setError('Informe seu e-mail.');
      return;
    }
    setLoading(true);
    try {
      const response = await api.post('/auth/forgot-password', { email });
      console.log('Resposta recebida:', response);
      // Compatível com response.data.success ou response.success
      if ((response.data && response.data.success) || response.success) {
        setSuccess('E-mail de recuperação enviado com sucesso! Verifique sua caixa de entrada.');
      } else {
        setError(response.data?.message || response.message || 'Erro ao enviar recuperação. Tente novamente.');
      }
    } catch (err) {
      console.error('Erro no catch:', err);
      console.error('err.response:', err.response);
      console.error('err.response?.data:', err.response?.data);
      if (
        err.response &&
        err.response.data &&
        err.response.data.success &&
        err.response.status >= 200 && err.response.status < 300
      ) {
        setSuccess('E-mail de recuperação enviado com sucesso! Verifique sua caixa de entrada.');
      } else {
        setError(
          err.response?.data?.message || 'Erro ao enviar recuperação. Tente novamente.'
        );
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: 'transparent', padding: 3 }}>
      <Container maxWidth="xs">
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
          <Paper elevation={3} sx={{ p: 4, width: '100%', bgcolor: 'rgba(255,255,255,0.95)', boxShadow: 6, borderRadius: 5 }}>
            <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2 }}>
              <img
                src={process.env.PUBLIC_URL + '/assets/gerencie_logo_nova.png'}
                alt="Logo Gerencie"
                style={{ maxWidth: 100, maxHeight: 100 }}
              />
            </Box>
            <Typography variant="h5" fontWeight="bold" color="primary" gutterBottom align="center">
              Recuperar Senha
            </Typography>
            <Typography variant="body2" color="textSecondary" gutterBottom align="center">
              Informe seu e-mail cadastrado para receber o link de redefinição.
            </Typography>
            <form onSubmit={handleSubmit}>
              <TextField
                label="E-mail"
                type="email"
                fullWidth
                margin="normal"
                value={email}
                onChange={e => setEmail(e.target.value)}
                required
                disabled={!!success}
                sx={{ backgroundColor: '#fff', borderRadius: 2 }}
              />
              {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
              {success && <Alert severity="success" sx={{ mt: 2 }}>{success}</Alert>}
              <Button type="submit" variant="contained" color="primary" fullWidth disabled={loading || !!success} sx={{ mt: 2, borderRadius: 2, fontWeight: 600, fontSize: 16 }}>
                {loading ? <CircularProgress size={24} /> : 'Enviar link de recuperação'}
              </Button>
            </form>
            {success && (
              <Button
                fullWidth
                variant="text"
                sx={{ mt: 2, color: '#1976d2', fontWeight: 500 }}
                href="/login"
              >
                Voltar para o login
              </Button>
            )}
          </Paper>
        </Box>
      </Container>
    </Box>
  );
}

export default RecuperarSenha;
